module.exports = __webpack_public_path__ + "img/c2.b5f39dff.png";